<template>
	<div class="statuses-container" v-if="unreadEventsCount > 0">
		<div class="statuses-floater mouse-pointer" @click="onClick">
			<ThunderboltFilled class="events-counter-icon"/> {{ $t('events.unreadCount', unreadEventsCount) }}
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';
import { ThunderboltFilled } from '@ant-design/icons-vue';

import { useEventsStore } from '@/stores/events';
import { useRoute, useRouter } from 'vue-router';

export default {
	components: {
		ThunderboltFilled,
	},
	emits: ['click'],
	setup(props, { emit }) {
		const eventsStore = useEventsStore();
		const unreadEventsCount = computed(() => eventsStore.unreadCount);

		const route = useRoute();
		const router = useRouter();
		const onClick = () => {
			emit('click');
			eventsStore.setShowArchived(false);
			if (route.name === 'events') {
				eventsStore.refreshAll();
			} else {
				router.push({ name: 'events' });
			}
		};

		return {
			unreadEventsCount,
			onClick,
		}
	},
}
</script>
<style scoped>
@import '@/assets/floaters.css';

.events-counter-icon {
	color: #831954;
	margin-inline-end: 4px;
}
</style>
